export { default } from './BoardDetailList';
